import { reactive } from "vue";

export type Book = {
  id: number;
  code: string;
  name: string;
  company_name: string;
  status?: string;
  role?: string;
};

export type User = {
  id: number;
  username: string;
  displayName: string;
  isPlatformAdmin: boolean;
};

export const state = reactive({
  token: localStorage.getItem("cs_token") || "",
  user: null as User | null,
  books: [] as Book[],
  bookId: Number(localStorage.getItem("cs_book_id") || 0),
});

export function setSession(token: string, user: User) {
  state.token = token;
  state.user = user;
  localStorage.setItem("cs_token", token);
}

export function setBooks(books: Book[]) {
  state.books = books;
  if (!state.bookId && books.length) {
    setBookId(books[0].id);
  }
}

export function setBookId(id: number) {
  state.bookId = id;
  localStorage.setItem("cs_book_id", String(id));
}

export function logout() {
  state.token = "";
  state.user = null;
  state.books = [];
  state.bookId = 0;
  localStorage.removeItem("cs_token");
  localStorage.removeItem("cs_book_id");
}

export function currentBook(): Book | undefined {
  return state.books.find((b) => b.id === state.bookId);
}
